<template>
    <div class="b-overlay-wrap position-relative d-flex flex-column h-100 w-100">
        <div class="b-overlay-wrap position-relative w-100 h-100 overflow-auto">
            <b-card no-body class="d-flex flex-column h-100 w-100 rounded-0 p-0 m-0"
                    :variant="Variant">
                <b-tabs card content-class="bg-white p-0 m-0 b-overlay-wrap position-relative overflow-auto h-100 w-100"
                        active-nav-item-class="text-secondary"
                        nav-class="p-0 m-0" v-model="tabIndex"
                        nav-wrapper-class="m-0 p-0 mt-2 border"
                        :fill="($screen.breakpoint === 'xs' || $screen.breakpoint === 'sm')"
                        class="m-0 p-0 h-100 d-flex flex-column">
                    <!-- Liste des facteurs d'influence-->
                    <b-tab :title="$t('InfluencyFactorsList')" active
                           class="p-0 m-0 b-overlay-wrap position-relative h-100">
                        <!-- Liste des facteurs -->
                        <b-container fluid class="m-0 p-0 h-100 b-overlay-wrap position-relative">
                            <b-row class="m-0 p-0 h-100">
                                <b-col class="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 m-0 p-0 pr-2
                                d-flex flex-column h-100 b-overlay-wrap position-relative">
                                    <b-card no-body class="p-0 m-0 w-100 bg-white d-flex flex-column h-100">
                                        <b-row class="m-0 p-1">
                                            <b-col class="m-0 p-0 py-2 justify-content-between">
                                                <strong>{{ $t('FactorsList') }} :</strong>
                                            </b-col>
                                            <b-col class="m-0 p-0" md="auto">
                                                <b-button @click="initFactor(!$store.getters['CheckAction']('Write', undefined, Action))" v-b-tooltip.hover
                                                          :title="$t('AddAFactor')" pill size="sm"
                                                          :disabled="!$store.getters['CheckAction']('Add', undefined, Action)"
                                                          class="m-1"
                                                          :variant="'outline-'+Variant">
                                                    <b-icon icon="plus"/>
                                                    <small>
                                                        {{ $t('AddAFactor') }} <!-- Ajouter un facteur-->
                                                    </small>
                                                </b-button>
                                                <b-button v-b-tooltip.hover v-b-modal.modalFactorType class="m-1"
                                                          :title="$t('AddATypeFactor')" pill size="sm"
                                                          :disabled="!$store.getters['CheckAction']('Add', undefined, Action)"
                                                          :variant="'outline-'+Variant">
                                                    <b-icon icon="plus"/>
                                                    <small v-html="$t('AddATypeFactor')" /><!-- Ajouter un facteur <b>type</b> -->
                                                </b-button>
                                                <b-button @click="deleteFactors(factorList);" v-b-tooltip.hover
                                                          :title="$t('DeleteAFactor')" pill size="sm"
                                                          :disabled="!$store.getters['CheckAction']('Delete', undefined, Action)"
                                                          class="m-1"
                                                          :variant="'outline-'+Variant"><!-- Supprimer un facteur -->
                                                    <b-icon icon="x"/>
                                                    <small>
                                                        {{ $t('DeleteAFactor') }}<!-- Supprimer un facteur -->
                                                    </small>
                                                </b-button>
                                            </b-col>
                                        </b-row>
                                        <b-row class="p-0 m-0 h-100 w-100 d-flex flex-column">
                                            <b-col class="p-0 m-0 overflow-auto">
                                                <b-form-checkbox-group id="factorList" v-model="factorList"
                                                                       name="factorList"
                                                                       class="d-flex flex-column h-100 b-overlay-wrap position-relative">
                                                    <b-table striped hover bordered small
                                                             :head-row-variant="Variant"
                                                             :fields="[{ key: 'Selected', label: '',
                                                                        class: 'text-center',
                                                                        thStyle: { width: '40px' }},
                                                                   { key: 'Name', label: $t('Label') /* 'Désignation' */, sortable: true},
                                                                   { key: 'Code', label: $t('Code') /* 'Code' */, sortable: true},
                                                                   { key: 'Unit', label: $t('Unit') /* 'Unité' */, sortable: true},
                                                                   { key: 'Type', label: $t('Type') /* 'Type' */, sortable: true},
                                                                   { key: 'Temporality', label: $t('Temporality') /* 'Temporalité' */,
                                                                        sortable: true},
                                                                   { key: 'IsStatic', label: $t('Relevant') /* 'Pertinent' */,
                                                                        sortable: true, class: 'text-center'},
                                                                   { key: 'IsGlobal', label: $t('Overall') /* 'Global' */, sortable: true,
                                                                        class: 'text-center'},
                                                                   { key: 'CumulNode', label: $t('MultiNodeAccumulation') /* 'Cumul multi-nœud' */,
                                                                        sortable: true, class: 'text-center'}]"
                                                             no-border-collapse responsive selectable
                                                             select-mode="single" :items="adminFactors"
                                                             class="bg-transparent"
                                                             table-class="b-overlay-wrap position-relative overflow-auto h-100"
                                                             @row-selected="loadFactor">
                                                        <template #cell(Selected)="raw">
                                                            <b-form-checkbox :id="'checkbox-factor-' + raw.item.Id"
                                                                             :name="'checkbox-factor-' + raw.item.Id"
                                                                             :value="raw.item.Id" class="mr-0"/>
                                                        </template>
                                                        <template #cell(Unit)="row">
                                                            {{
                                                                row.value > 0 ? factorUnitList.find(a => a.value === row.value).text : ''
                                                            }}
                                                        </template>
                                                        <template #cell(Type)="row">
                                                            {{
                                                                row.value === 1 ? $t('Cumulative') /* 'Cumulable' */ : (row.value === 2 ? $t('Average') /* 'Moyenne' */ : (row.value === 3 ? $t('Percentage') /* 'Pourcentage' */ : ''))
                                                            }}
                                                        </template>
                                                        <template #cell(Temporality)="row">
                                                            {{
                                                                    row.value === 1 ? $t('Range') /* 'Borné' */ : (row.value === 2 ? $t('Immediate') /* 'Instantané' */ : (row.value === 3 ? $t('Indexed') /* 'Indexé' */ : ''))
                                                            }}
                                                        </template>
                                                        <template #cell(IsStatic)="row">
                                                            <b-icon icon="check-circle-fill" :variant="Variant"
                                                                    v-if="!row.value"/>
                                                            <b-icon icon="circle" v-if="row.value"/>
                                                        </template>
                                                        <template #cell(IsGlobal)="row">
                                                            <b-icon icon="check-circle-fill" :variant="Variant"
                                                                    v-if="row.value"/>
                                                            <b-icon icon="circle" v-if="!row.value"/>
                                                        </template>
                                                        <template #cell(CumulNode)="row">
                                                            <b-icon icon="check-circle-fill" :variant="Variant"
                                                                    v-if="row.value"/>
                                                            <b-icon icon="circle" v-if="!row.value"/>
                                                        </template>
                                                    </b-table>
                                                </b-form-checkbox-group>
                                            </b-col>
                                        </b-row>
                                    </b-card>
                                </b-col>
                                <b-col class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 m-0 p-0"
                                       style="border-left: 1px solid lightgrey; border-right: 1px solid lightgrey;
                                   border-bottom: 1px solid lightgrey">
                                    <b-card no-body class="p-0 m-0 w-100 h-100 d-flex flex-column"
                                            :bg-variant="factorDisabled ? 'light' : Variant">
                                        <b-card-header
                                            class="m-0 p-1 pl-2 d-flex justify-content-between font-weight-bold ">
                                            <strong class="align-self-center">
                                                {{ $t('Detail') }} : {{ factorHeader }}
                                                {{ factorIsManaged ? $t('TypeFactor') : '' }}
                                            </strong>
                                            <div>
                                                <b-button v-b-tooltip.hover :title="$t('Save')" class="m-1 btn-circle-small" size="sm"
                                                          :variant="'outline-'+Variant" :disabled="factorDisabled"
                                                          @click="saveFactor(factorId)" pill><!-- Enregistrer -->
                                                    <i class="bi-floppy"/>
                                                </b-button>
                                                <b-button :title="$t('Cancel')" size="sm"
                                                          :variant="'outline-'+Variant" v-b-tooltip.hover
                                                          class="m-1"
                                                          :disabled="factorDisabled"
                                                          @click="initFactor(true)" pill>
                                                    <b-icon icon="x"/>
                                                    <small>
                                                        {{ $t('Cancel') }}
                                                    </small>
                                                </b-button>
                                            </div>
                                        </b-card-header>
                                        <b-row class="m-0 p-0 d-flex flex-column h-100 mh-100 bg-white" disabled="true">
                                            <b-col class="m-0 p-0 overflow-auto">
                                                <b-row class="m-0 p-0">
                                                    <b-col class="m-0 p-0">
                                                        <b-form-input hidden="true" v-model="factorId"></b-form-input>
                                                        <b-form-group label-cols="4" content-cols="8"
                                                                      label-class="pl-2 font-weight-bold "
                                                                      class="p-0 m-0 py-1" :label="$t('Label')"
                                                                      label-for="input-name">
                                                            <b-form-input id="input-name" v-model="factorName"
                                                                          :disabled="factorDisabled"
                                                                          :placeholder="$t('Label')"></b-form-input><!-- Désignation -->
                                                        </b-form-group>
                                                        <b-form-group label-cols="4" content-cols="8"
                                                                      label-class="pl-2 font-weight-bold "
                                                                      class="p-0 m-0 py-1" :label="$t('Code')"
                                                                      label-for="input-code">
                                                            <b-form-input id="input-code" v-model="factorCode"
                                                                          :disabled="factorDisabled"
                                                                          :placeholder="$t('Code')"></b-form-input><!-- Code-->
                                                        </b-form-group>
                                                        <b-form-group label-cols="4" content-cols="8"
                                                                      label-class="pl-2 font-weight-bold "
                                                                      class="p-0 m-0 py-1" :label="$t('Unit')"
                                                                      label-for="select-unit">
                                                            <multiselect v-model="factorUnit" id="select-unit"
                                                                         :options="factorUnitList"
                                                                         :close-on-select="true"
                                                                         :allow-empty="false" :show-labels="true"
                                                                         :placeholder="$t('Unit')" label="text"
                                                                         track-by="value"
                                                                         selectLabel="" selectedLabel=""
                                                                         deselectLabel=""
                                                                         :multiple="false" :disabled="factorDisabled"
                                                                         class="p-0 m-0"><!-- Unité-->
                                                                <template slot="option" slot-scope="props">
                                                                    <div class="font-weight-bold">
                                                                        {{ props.option.text }}
                                                                    </div>
                                                                    {{ props.option.comment }}
                                                                </template>
                                                            </multiselect>
                                                        </b-form-group>
                                                        <b-form-group class="p-0 pl-1 m-0" label-cols="4"
                                                                      content-cols="8"
                                                                      label-class="p-0 pt-0 pl-2 m-0 font-weight-bold "
                                                                      :label="$t('Leverage')"
                                                                      label-for="radio-group-isStatic"><!-- Influence-->
                                                            <b-form-radio-group id="radio-group-isStatic"
                                                                                v-model="factorIsStatic"
                                                                                :disabled="factorDisabled"
                                                                                name="Influence"
                                                                                plain class="p-0 m-0">
                                                                <b-row class="m-0 p-0">
                                                                    <b-col class="m-0 p-0">
                                                                        <b-form-radio class="m-0 p-0" id="Radio_Static"
                                                                                      :value="true">
                                                                            {{  $t('Static') }}     <!-- Statique -->
                                                                        </b-form-radio>
                                                                    </b-col>
                                                                    <b-col class="m-0 p-0">
                                                                        <b-form-radio class="m-0 p-0"
                                                                                      id="Radio_Pertinent"
                                                                                      :value="false">
                                                                            {{  $t('Relevant') }}   <!-- Pertinent-->
                                                                        </b-form-radio>
                                                                    </b-col>
                                                                </b-row>
                                                            </b-form-radio-group>
                                                        </b-form-group>
                                                        <b-card class="bg-gray m-0 mx-2 text-justify mb-2"
                                                                body-class="m-0 p-2">
                                                            <b-card-text class="m-0 p-0">
                                                                {{ $t('LeverageDescription') }}
                                                                <!-- L'influence du facteur permet de définir au sens de la
                                                                norme
                                                                ISO 50006 le comportement du facteur. Un facteur
                                                                pertinent
                                                                varie constamment pendant la périodicité du suivi alors
                                                                qu'un facteur statique sera moins (voire pas) fluctuant
                                                                et
                                                                donc moins pertinent en terme d'influence. -->
                                                            </b-card-text>
                                                        </b-card>
                                                        <b-form-group class="p-0 pl-1 m-0" label-cols="4"
                                                                      content-cols="8"
                                                                      label-for="radio-group-isGlobal"
                                                                      label-class="p-0 pt-0 pl-2 m-0 font-weight-bold "
                                                                      :label="$t('Target')"><!-- Cible-->
                                                            <b-form-radio-group id="radio-group-isGlobal"
                                                                                :disabled="factorDisabled"
                                                                                v-model="factorIsGlobal" name="Cible"
                                                                                plain
                                                                                class="p-0 m-0">
                                                                <b-row class="m-0 p-0">
                                                                    <b-col class="m-0 p-0">
                                                                        <b-form-radio class="m-0 p-0" id="Radio_Affect"
                                                                                      :value="false">
                                                                            {{ $t('Allocation') }}<!-- Affectation -->
                                                                        </b-form-radio>
                                                                    </b-col>
                                                                    <b-col class="m-0 p-0">
                                                                        <b-form-radio class="m-0 p-0" id="Radio_Global"
                                                                                      :value="true">
                                                                            {{ $t('Overall') }}<!-- Global -->
                                                                        </b-form-radio>
                                                                    </b-col>
                                                                </b-row>
                                                            </b-form-radio-group>
                                                        </b-form-group>
                                                        <b-card class="bg-light m-0 mx-2 text-justify mb-2"
                                                                body-class="m-0 p-2">
                                                            <b-card-text class="m-0 p-0">
                                                                {{  $t('TargetFactorDescription') }}
                                                                <!-- La cible du facteur traduit la manière de renseigner
                                                                celui-ci. Un facteur global sera indépendant du nœud
                                                                sélectionné dans l'arborescence alors qu'un facteur
                                                                affectable permettra de renseigner ses valeurs nœud
                                                                par nœud. -->
                                                            </b-card-text>
                                                        </b-card>
                                                        <b-form-group class="p-0 pl-1 m-0" label-cols="4"
                                                                      content-cols="8"
                                                                      label-for="radio-group-cumulNode"
                                                                      label-class="p-0 pt-0 pl-2 m-0 font-weight-bold "
                                                                      :label="$t('MultiNodeAccumulation')"
                                                                      :hidden="factorIsGlobal"><!-- Cumul multi-nœud -->
                                                            <b-form-radio-group id="radio-group-cumulNode"
                                                                                v-model="factorCumulNode"
                                                                                :disabled="factorDisabled"
                                                                                name="Cumul multi-nœud"
                                                                                plain class="p-0 m-0">
                                                                <b-row class="m-0 p-0">
                                                                    <b-col class="m-0 p-0">
                                                                        <b-form-radio class="m-0 p-0" id="Radio_Yes"
                                                                                      :value="true">
                                                                            {{ $t('Yes') }} <!-- Oui -->
                                                                        </b-form-radio>
                                                                    </b-col>
                                                                    <b-col class="m-0 p-0">
                                                                        <b-form-radio class="m-0 p-0" id="Radio_No"
                                                                                      :value="false">
                                                                            {{ $t('No') }}<!-- Non -->
                                                                        </b-form-radio>
                                                                    </b-col>
                                                                </b-row>
                                                            </b-form-radio-group>
                                                        </b-form-group>
                                                        <b-card class="bg-light m-0 mx-2 text-justify mb-2"
                                                                body-class="m-0 p-2"
                                                                :hidden="factorIsGlobal">
                                                            <b-card-text class="m-0 p-0">
                                                                {{ $t('NodeAccumulationDescription') }}
                                                                <!-- Cochez oui si les données se cumulent entre les nœuds
                                                                (par
                                                                exemple la surface chauffée) et non si cette donnée ne
                                                                se
                                                                cumule pas (par exemple température moyenne). -->
                                                            </b-card-text>
                                                        </b-card>
                                                        <b-form-group class="p-0 pl-1 m-0" label-cols="4"
                                                                      content-cols="8"
                                                                      label-for="radio-group-type"
                                                                      label-class="p-0 pt-0 pl-2 m-0 font-weight-bold "
                                                                      :label="$t('Type')">
                                                            <b-form-radio-group id="radio-group-type"
                                                                                v-model="factorType"
                                                                                name="Type" class="p-0 m-0"
                                                                                :disabled="factorDisabled" plain>
                                                                <b-row class="m-0 p-0">
                                                                    <b-col class="m-0 p-0">
                                                                        <b-form-radio id="Radio_Combinable"
                                                                                      :value="1">
                                                                            {{ $t('Cumulative') }}    <!-- Cumulable -->
                                                                        </b-form-radio>
                                                                    </b-col>
                                                                    <b-col class="m-0 p-0">
                                                                        <b-form-radio class="m-0 p-0" id="Radio_Average"
                                                                                      :value="2">
                                                                            {{ $t('Average') }}    <!-- Moyenne -->
                                                                        </b-form-radio>
                                                                    </b-col>
                                                                    <b-col class="m-0 p-0" v-show="false">
                                                                        <b-form-radio class="m-0 p-0" id="Radio_Percent"
                                                                                      :value="3">
                                                                            {{ $t('Percentage') }}   <!--  Pourcentage -->
                                                                        </b-form-radio>
                                                                    </b-col>
                                                                </b-row>
                                                            </b-form-radio-group>
                                                        </b-form-group>
                                                        <b-card class="bg-light m-0 mx-2 text-justify mb-2"
                                                                body-class="m-0 p-2">
                                                            <b-card-text class="m-0 p-0">
                                                                {{ $t('FactorTypeDescription')}}
                                                                <!-- Le type du facteur permet de différencier les facteurs
                                                                cumulables dans le temps (fréquentation par exemple)
                                                                d'un facteur moyenné dans le temps (température par
                                                                exemple) et donc non cumulable sur des périodes plus
                                                                longues. -->
                                                            </b-card-text>
                                                        </b-card>
                                                        <b-form-group class="p-0 pl-1 m-0" label-cols="4"
                                                                      content-cols="8"
                                                                      label-for="radio-group-temporality"
                                                                      label-class="p-0 pt-0 pl-2 m-0 font-weight-bold "
                                                                      :label="$t('Temporality')"><!-- Temporalité -->
                                                            <b-form-radio-group id="radio-group-temporality"
                                                                                v-model="factorTemporality"
                                                                                :disabled="factorDisabled"
                                                                                :name="$t('Temporality')" plain
                                                                                class="m-0 p-0">
                                                                <b-row class="m-0 p-0">
                                                                    <b-col class="m-0 p-0">
                                                                        <b-form-radio id="Radio_Limited" :value="1">
                                                                            {{ $t('Range') }}   <!-- Borné -->
                                                                        </b-form-radio>
                                                                    </b-col>
                                                                    <b-col class="m-0 p-0">
                                                                        <b-form-radio class="m-0 p-0" id="Radio_Instant"
                                                                                      :value="2">
                                                                            {{ $t('Immediate') }}  <!-- Instantané -->
                                                                        </b-form-radio>
                                                                    </b-col>
                                                                    <b-col class="m-0 p-0">
                                                                        <b-form-radio class="m-0 p-0" id="Radio_Indexed"
                                                                                      :value="3">
                                                                            {{ $t('Indexed') }}  <!-- Indexé -->
                                                                        </b-form-radio>
                                                                    </b-col>
                                                                </b-row>
                                                            </b-form-radio-group>
                                                        </b-form-group>
                                                        <b-card class="bg-light m-0 mx-2 text-justify mb-2"
                                                                body-class="m-0 p-2">
                                                            <b-card-text class="m-0 p-0">
                                                                {{ $t('TemporalityFactorDescription') }}
                                                                <!-- La temporalité du facteur permet de différencier les
                                                                facteurs bornés sur plage de temps et les facteurs
                                                                instantanés et indexés qui sont sur un instant donné. -->
                                                            </b-card-text>
                                                        </b-card>
                                                        <b-form-group label-cols="4" content-cols="8"
                                                                      label-class="pl-2 font-weight-bold"
                                                                      :hidden="factorIsGlobal"
                                                                      class="p-0 m-0 py-1" :label="$t('NodeType')"
                                                                      label-for="input-horizontal"><!-- Type de nœud -->
                                                            <multiselect v-model="factorTypeObject"
                                                                         :options="factorTypeObjectList"
                                                                         :close-on-select="true" :allow-empty="false"
                                                                         :show-labels="true" :placeholder="$t('NodeType')"
                                                                         label="text" track-by="value" selectLabel=""
                                                                         selectedLabel="" deselectLabel=""
                                                                         :multiple="true"
                                                                         :disabled="factorDisabled" class="p-0 m-0">
                                                            </multiselect>
                                                        </b-form-group>
                                                        <b-card class="bg-light m-0 mx-2 text-justify mb-2"
                                                                body-class="m-0 p-2"
                                                                :hidden="factorIsGlobal">
                                                            <b-card-text class="m-0 p-0">
                                                                {{ $t('NodeTypeSelection') }}
                                                                <!-- La sélection du type de nœud permet de savoir à quel
                                                                type
                                                                de nœud de l'arborescence patrimoniale ce facteur
                                                                peut être affecté. -->
                                                            </b-card-text>
                                                        </b-card>
                                                        <b-form-group :label="$tc('Remark', 1)" label-for="textarea-remark"
                                                                      class="p-0 m-2 py-1"
                                                                      label-class="font-weight-bold"><!-- Remarque -->
                                                            <b-form-textarea id="textarea-remark"
                                                                             :disabled="factorDisabled"
                                                                             v-model="factorRemark"></b-form-textarea>
                                                        </b-form-group>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                        </b-row>
                                    </b-card>
                                </b-col>
                            </b-row>
                        </b-container>
                    </b-tab>

                    <b-tab :title="$t('OverallFactors')" class="m-0 p-0 b-overlay-wrap position-relative h-100">
                        <!-- Facteurs globals -->
                        <FactorsEntering :FactorList="globalFactorsEntering" :Variant="Variant ? Variant : 'quartary'"
                                         :Action="Action"
                                         :HaveToSave.sync="haveToSave"
                                         PortalDataSaveButton="PortalFactorDataSave"/>
                    </b-tab>
                </b-tabs>
            </b-card>

            <!-- Modal - Liste des facteurs Type -->
            <b-modal id="modalFactorType" :title="$t('TypeFactorsList')" centered size="xl"
                     header-class="m-0 py-1 bg-light"
                     body-class="m-0 py-1" footer-class="m-0 py-1 bg-light">
                <div class="m-0 p-0 w-100">
                    <b-row cols="4" class="m-0 p-0">
                        <b-col class="p-1 m-0" v-for="(factor, index) in managedFactors" :key="factor.Id">
                            <b-form-checkbox v-model="factor.IsToogle"
                                             name="check-button" button :button-variant="'outline-' + Variant"
                                             class="w-100 factorType border-1">
                                <strong>{{ factor.Name }}</strong><br/>
                                <small>
                                    {{
                                        factorUnitList.find(a => a.value == factor.Unit) ? factorUnitList.find(a => a.value == factor.Unit).text : ''
                                    }}
                                </small>
                            </b-form-checkbox>
                        </b-col>
                    </b-row>
                </div>
                <template #modal-footer="{ close }">
                    <div class="w-100 d-flex flex-row-reverse p-0 m-0">
                        <b-button v-b-tooltip.hover :title="$t('Cancel')" class="m-1" size="sm" pill
                                  :variant="'outline-' + Variant" @click="close()">
                            {{ $t('Cancel') }}  <!-- Annuler -->
                        </b-button>
                        <b-button v-b-tooltip.hover :title="$t('Add')" class="m-1" size="sm" pill
                                  :variant="Variant" @click="saveFactorType();close();">
                            <b-icon icon="plus"/>
                            {{ $t('Add') }}  <!-- Ajouter -->
                        </b-button>
                    </div>
                </template>
            </b-modal>
        </div>
    </div>
</template>


<script lang="ts">
import {Component, InjectReactive, Prop, Vue, Watch} from "vue-property-decorator";
import FactorsEntering from "@/components/commons/FactorsEntering.vue";
import Dictionary from "@/types/Dictionary";
import axios from "axios";
import {API_URL} from "@/App.settings";
import Multiselect from 'vue-multiselect';
/** Traductions */
import locales from "./locales/Factors.json";

//#region Types

type Factor = {
    Id: number,
    Name: string,
    Code: string,
    Type?: FactorTypeEnum,
    Temporality?: FactorTemporalityEnum,
    Unit?: number,
    IsStatic: boolean,
    IsGlobal: boolean,
    CumulNode: boolean,
    IsManaged: boolean,
    IsVisible: boolean,
    Remark?: string,
    ListType?: string[],
    IsToogle?: boolean,
    HasData?: boolean,
    Selected?: boolean
}

enum FactorTypeEnum {
    Combinable = 1,
    Average = 2,
    Percent = 3
}

enum FactorTemporalityEnum {
    Limited = 1,
    Instant = 2,
    Indexed = 3
}

//#endregion Types

/** Composant d'administration des facteurs */
@Component({
    methods: {},
    components: {
        Multiselect,
        FactorsEntering,
    },
    i18n: {	messages: locales }
})
export default class Factors extends Vue {
    /** Variant de couleur à appliquer */
    @InjectReactive( )
    private Variant!: string;

    /** Droit disponible pour l'utilisateur en cours */
    @Prop()
    public Action!: string;

    //#region Initialisation des facteurs

    private factorList: number[] = [];
    private factorId: number = 0;
    private factorHeader: string = '';
    private factorName: string = null;
    private factorCode: string = null;
    private factorUnit: { value: number, text: string, comment: string } = null;
    private factorUnitList: { value: number, text: string, comment: string }[] = [];
    private factorIsStatic: boolean = false;
    private factorIsGlobal: boolean = false;
    private factorCumulNode: boolean = false;
    private factorType: FactorTypeEnum = FactorTypeEnum.Combinable;
    private factorTemporality: FactorTemporalityEnum = FactorTemporalityEnum.Instant;
    private factorTypeObject: { value: string, text: string }[] = [];
    private factorTypeObjectList: { value: string, text: string }[] = [];
    private factorRemark: string = '';
    private factorDisabled: boolean = false;
    private factorIsManaged: boolean = false;

    private managedFactors?: Factor[] = [];
    private adminFactors?: Factor[] = [];

    //#endregion Fin - Initialisation des facteurs


    //#region Facteurs globaux

    /** liste des facteurs globaux **/
    private globalFactors: Factor[] = [];
    private globalFactorsEntering: any = {};
    /** Le bouton Sauvegarder doit être actif */
    private haveToSave: boolean = false;

    //#endregion Fin - Facteurs globaux

    /** Onglet **/
    private tabIndex: number = 1;

    /** nœud */
    @Prop()
    public NodeId!: String;

    public mounted() {
        this.initFactor();

        // Chargement des paramètres par défaut
        const args: Dictionary<any> = {};
        args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";

        // Récupération de la liste des facteurs
        axios.post(API_URL + "Factors/Load", args).then((response) => {
            if (response && response.data) {
                console.debug("Factors - configure - response.data", response.data);
                this.adminFactors = response.data.Results.admin;
                this.managedFactors = response.data.Results.managed;
                for (let i = 0; i < this.managedFactors.length; i++) {
                    this.managedFactors[i].IsToogle = (this.adminFactors.findIndex(a => a.Id == this.managedFactors[i].Id) > -1);
                }

                this.factorUnitList = response.data.Results.unit;
                this.globalFactors = response.data.Results.global;
                for(let i=0; i< this.globalFactors.length; i++) {
                    let a = this.globalFactors[i];
                    this.globalFactorsEntering[a.Id] = {
                        Id: a.Id, Label: a.Name,
                        CumulNode: a.CumulNode, IsGlobal: a.IsGlobal, IsStatic: a.IsStatic, Name: "Factor" + a.Id,
                        Unit: this.factorUnitList.find(b => b.value === a.Unit) ? this.factorUnitList.find(b => b.value === a.Unit).text : '',
                        FactorType: a.Type, HasData: a.HasData, Temporality: a.Temporality, Value: [],
                    }
                }
                this.factorTypeObjectList = response.data.Results.objectType;
                console.debug("Factors - configure - globalFactors : %O, globalFactorsEntering: %O", this.globalFactors, this.globalFactorsEntering);
            }
        }), (error: any) => {
            console.error(error);
            this.$bvToast.toast(this.$t('AnErrorOccured').toString(), {    /** "Une erreur s'est produite" */
                title: this.$t('Error').toString(),    // "Erreur"
                autoHideDelay: 10000,
                variant: "danger",
                solid: true,
                appendToast: true,
                toaster: "b-toaster-top-center"
            });
        };
    }

    /** Initialisation des facteurs **/
    private initFactor(disabled: boolean = true) {
        this.factorId = 0;
        this.factorHeader = disabled ? '' : this.$t('NewFactor').toString();    // 'Nouveau facteur'
        this.factorName = '';
        this.factorCode = '';
        this.factorUnit = null;
        this.factorIsGlobal = false;
        this.factorCumulNode = false;
        this.factorType = FactorTypeEnum.Combinable;
        this.factorTemporality = FactorTemporalityEnum.Instant;
        this.factorTypeObject = [];
        this.factorDisabled = disabled;
        this.factorIsManaged = false;
        this.factorRemark = '';
    }

    private loadFactor(item) {
        console.debug('Factors.vue - Administration - loadFactor - item', item);
        if (item.length > 0) {
            let idFactor = item[0].Id;

            this.initFactor(false);
            let factor = this.adminFactors.find(a => a.Id == idFactor);
            if (factor != undefined) {
                this.factorId = factor.Id;
                this.factorHeader = factor.Name;
                this.factorName = factor.Name;
                this.factorCode = factor.Code;
                this.factorUnit = this.factorUnitList.find(a => a.value == factor.Unit);
                this.factorIsGlobal = factor.IsGlobal;
                this.factorCumulNode = factor.CumulNode;
                this.factorIsStatic = factor.IsStatic;
                this.factorType = factor.Type;
                this.factorTemporality = factor.Temporality;
                this.factorTypeObject = factor.ListType.map(a => this.factorTypeObjectList.find(b => b.value == a));
                this.factorRemark = factor.Remark;
                this.factorDisabled = factor.IsManaged || !this.$store.getters['CheckAction']('Write', undefined, this.Action);
                this.factorIsManaged = factor.IsManaged;
            }
        }
    }

    private saveFactor(factorId) {

        if (this.factorName && this.factorCode && this.factorUnit != undefined && this.factorUnit.value > 0) {
            let factor: Factor = {
                Id: factorId,
                Name: this.factorName,
                Code: this.factorCode,
                Type: this.factorType,
                Temporality: this.factorTemporality,
                Unit: this.factorUnit != undefined ? this.factorUnit.value : undefined,
                IsStatic: this.factorIsStatic,
                IsGlobal: this.factorIsGlobal,
                CumulNode: this.factorCumulNode,
                IsManaged: false,
                IsVisible: true,
                Remark: this.factorRemark,
                ListType: this.factorTypeObject != undefined ? this.factorTypeObject.map(a => a.value) : []
            };
            this.saveBDDFactor(factor);
        } else {
            this.$bvModal.msgBoxOk(this.$t('MsgBadInfluencyFactorDefinition').toString() /* "Le facteur d'influence est mal défini. Veuillez indiquer une désingation, un code et une unité." */, {
                title: this.$t('AddInfluencyFactor').toString(), //"Ajout d'un facteur d'influence"
                okVariant: 'light',
                hideHeaderClose: false,
                centered: true,
            });
        }
    }

    private saveBDDFactor(factor: Factor) {
        if (this.adminFactors.findIndex(f => f.Code == factor.Code && f.Id != factor.Id) > -1) {
            // Code déjà existant
            this.$bvToast.toast(this.$t('MsgFactorCodeAlreadyExist').toString() /* "Le code de ce facteur est déjà utilisé. Celui-ci ne peut pas être enregistré" */, {
                title: this.$t('CodeAlreadyExist').toString(), //"Erreur - Code déjà utilisé",
                autoHideDelay: 10000,
                variant: "danger",
                solid: true,
                appendToast: true,
                toaster: "b-toaster-top-center"
            });
            return;
        } else if (this.managedFactors.findIndex(f => f.Code == factor.Code) > -1) {
            // Code déjà existant
            this.$bvToast.toast(this.$t('MsgFactorTypeAlreadyExist').toString() /*"Le code de ce facteur est déjà utilisé au niveau des facteurs Type. Celui-ci ne peut pas être enregistré" */, {
                title: this.$t('FactorTypeCodeAlreadyExist').toString(), //"Erreur - Code déjà utilisé (Facteur Type)",
                autoHideDelay: 10000,
                variant: "danger",
                solid: true,
                appendToast: true,
                toaster: "b-toaster-top-center"
            });
            return;
        }

        // Enregistrement du facteur
        const args: Dictionary<any> = {};
        args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
        args["Factor"] = factor;

        axios.post(API_URL + "Factors/Save", args).then((response) => {
            if (response && response.data) {
                console.debug("Factors - save - response.data", response.data);
                this.adminFactors = response.data.Results.admin;
                this.managedFactors = response.data.Results.managed;
                for (let i = 0; i < this.managedFactors.length; i++) {
                    this.managedFactors[i].IsToogle = (this.adminFactors.findIndex(a => a.Id == this.managedFactors[i].Id) > -1);
                }
                this.globalFactors = response.data.Results.global;

                this.$bvToast.toast(this.$t('MsgSuccessfullSave').toString() /* "Le facteur d'influence a été enregistré avec succès." */, {
                    title: this.$t('SaveInfluencyFactor').toString(), //"Enregistrement du facteur d'influence",
                    autoHideDelay: 3000,
                    variant: "success",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-top-center"
                });

                this.initFactor();
            }
        }), (error: any) => {
            console.error(error);
            this.$bvToast.toast(this.$t('AnErrorOccured').toString() /* "Une erreur s'est produite lors de la sauvegarde du facteur" */, {
                title: this.$t('Error').toString(), // "Erreur",
                autoHideDelay: 10000,
                variant: "danger",
                solid: true,
                appendToast: true,
                toaster: "b-toaster-top-center"
            });
        };
    }

    private deleteFactors(factorList: number[]) {
        // Suppression des facteurs
        if (this.factorList.length > 0) {
            // let message =  "Confirmer-vous la suppression " + (this.factorList.length > 1 ? "des" : "du") +
            //     " facteur" + (this.factorList.length > 1 ? "s" : "") +
            //     " d'influence suivant ?";
            let message = this.$tc('MsgConfirmDelete', this.factorList.length).toString();

            for (let i = 0; i < this.factorList.length; i++) {
                let factor = this.adminFactors.find(a => a.Id == this.factorList[i]);
                if (factor)
                    message += (i > 0 ? ", " : "") + factor.Name;
            }

            this.$bvModal.msgBoxConfirm(message, {
                title: this.$t('DeleteInfluencyFactor').toString() /* "Suppression de facteurs d'influence" */, okVariant: this.Variant, cancelVariant: 'light',
                okTitle: this.$t('Delete').toString() /* 'Supprimer' */, cancelTitle: this.$t('No').toString() /* 'Non' */, hideHeaderClose: false, centered: true
            }).then(value => {
                if (value) {
                    const args: Dictionary<any> = {};
                    args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
                    args["FactorList"] = factorList;

                    axios.post(API_URL + "Factors/Delete", args).then((response) => {
                        if (response && response.data) {
                            console.debug("Factors - delete - response.data", response.data);
                            this.adminFactors = response.data.Results.admin;
                            this.managedFactors = response.data.Results.managed;
                            for (let i = 0; i < this.managedFactors.length; i++) {
                                this.managedFactors[i].IsToogle = (this.adminFactors.findIndex(a => a.Id == this.managedFactors[i].Id) > -1);
                            }
                            this.globalFactors = response.data.Results.global;

                            this.$bvToast.toast(this.$tc('MsgSuccessfullInfluencyFactorDelete', this.factorList.length).toString() /*(this.factorList.length > 1 ? "Les" : "Le") +
                                " facteur" + (this.factorList.length > 1 ? "s" : "") + " d'influence " +
                                (this.factorList.length > 1 ? "ont" : "a") + " été supprimé" + (this.factorList.length > 1 ? "s" : "")
                                + " avec succès." */,
                                {
                                    title: this.$t("DeleteInfluencyFactor").toString() /* "Suppression de facteurs d'influence" */,
                                    autoHideDelay: 3000,
                                    variant: "success",
                                    solid: true,
                                    appendToast: true,
                                    toaster: "b-toaster-top-center"
                                }
                            );

                            this.initFactor();
                        }
                    }), (error: any) => {
                        console.error(error);
                        this.$bvToast.toast(this.$t('AnErrorOccured').toString() /* "Une erreur s'est produite lors de la sauvegarde du facteur" */, {
                            title: this.$t('Error').toString() /* "Erreur" */,
                            autoHideDelay: 10000,
                            variant: "danger",
                            solid: true,
                            appendToast: true,
                            toaster: "b-toaster-top-center"
                        });
                    };
                }
            });
        } else {
            this.$bvToast.toast(this.$t('NoFactorSelected').toString() /* "Aucun facteur n'est sélectionné." */, {
                title: this.$t('DeleteInfluencyFactor').toString() /* "Suppression de facteurs d'influence" */,
                autoHideDelay: 10000,
                variant: "warning",
                solid: true,
                appendToast: true,
                toaster: "b-toaster-top-center"
            });
        }
    }

    public saveFactorType() {
        let managedFactor = this.managedFactors.filter(a => a.IsToogle).map(a => a.Id);

        // Enregistrement du facteur Type
        const args: Dictionary<any> = {};
        args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
        args["FactorList"] = managedFactor;

        axios.post(API_URL + "Factors/SaveManaged", args).then((response) => {
            if (response && response.data) {
                console.debug("Factors - saveFactorType - response.data", response.data);
                this.adminFactors = response.data.Results.admin;
                this.managedFactors = response.data.Results.managed;
                for (let i = 0; i < this.managedFactors.length; i++) {
                    this.managedFactors[i].IsToogle = (this.adminFactors.findIndex(a => a.Id == this.managedFactors[i].Id) > -1);
                }
                this.globalFactors = response.data.Results.global;

                this.$bvToast.toast(this.$tc("MsgSuccessfullFactorAddingDeleting", managedFactor.length).toString() /*(managedFactor.length > 1 ? "Les" : "Le") +
                    " facteur" + (managedFactor.length > 1 ? "s" : "") + " Type " +
                    (managedFactor.length > 1 ? "ont" : "a") + " été ajouté" + (managedFactor.length > 1 ? "s" : "") +
                    "/supprimé" + (managedFactor.length > 1 ? "s" : "") + " avec succès." */,
                    {
                        title: this.$t('AddingDeletingTypeFactor').toString() /* "Ajout/Suppression de facteurs Type" */,
                        autoHideDelay: 3000,
                        variant: "success",
                        solid: true,
                        appendToast: true,
                        toaster: "b-toaster-top-center"
                    });

                this.initFactor();
            }
        }), (error: any) => {
            console.error(error);
            this.$bvToast.toast(this.$t('AnErrorOccuredFactorTypeAdding').toString() /* "Une erreur s'est produite lors de l'ajout de facteur Type" */, {
                title: this.$t('Error').toString() /* "Erreur" */,
                autoHideDelay: 10000,
                variant: "danger",
                solid: true,
                appendToast: true,
                toaster: "b-toaster-top-center"
            });
        };
    }

    /** Fin - Initialisation des facteurs **/
}

</script>

<style scoped>
:deep(.factorType > .btn.active),
:deep(.factorType > .btn:hover) {
    color: white !important;
}

:deep(.factorType > label.btn) {
    width: 100% !important;
}
</style>